"use client";
import { Button } from "@base-ui/react/button";
import {
  usePathname,
  useRouter,
  useSearchParams,
} from "next/navigation";
import { useCallback } from "react";
import { cn } from "@/lib/utils";
import type { Category } from "@/types/category";

const CategoryList = ({ categories }: { categories: Category[] }) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const activeCategory = searchParams.get("category");

  const createQueryString = useCallback(
    (name: string, value: string) => {
      const params = new URLSearchParams(searchParams.toString());
      params.set(name, value);

      return params.toString();
    },
    [searchParams],
  );
  return (
    <>
      {categories.map((category) => (
        <Button
          aria-disabled={category.slug === activeCategory}
          className={cn(
            "rounded-full w-fit shrink-0 border border-neutral-200 text-neutral-800 px-4 py-2 font-medium hover:bg-brand-blue-100 hover:border-brand-blue-500 transition-colors",
            {
              "border-brand-blue-600 bg-brand-blue-600 text-white hover:bg-brand-blue-600":
                category.slug === activeCategory,
            },
          )}
          key={category.id}
          onClick={() =>
            router.push(
              `${pathname}?${createQueryString("category", category.slug)}`,
            )
          }
        >
          {category.name}
        </Button>
      ))}
    </>
  );
};

export default CategoryList;
